import { render, staticRenderFns } from "./AutoVerification.vue?vue&type=template&id=5a59fd96&scoped=true&"
import script from "./AutoVerification.vue?vue&type=script&lang=js&"
export * from "./AutoVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a59fd96",
  null
  
)

export default component.exports